export class Base
{
	private _mtmAuto=null;
	
	public setAuto(service)
	{
		this._mtmAuto	= service;
		return this;
	}
	public getAuto()
	{
		return this._mtmAuto;
	}
}